import { render, staticRenderFns } from "./PetFilters.vue?vue&type=template&id=2c34bcc3&scoped=true&"
import script from "./PetFilters.vue?vue&type=script&lang=js&"
export * from "./PetFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34bcc3",
  null
  
)

export default component.exports